// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UkcQ","placeholdersHeader":"styles_placeholdersHeader__35xqM","editorStyle":"styles_editorStyle__3PTo3","placeholdersBox":"styles_placeholdersBox__2rS9l"};